import { gql } from "@apollo/client";
// $strive_agent_last_name: String!,


// strive_agent_last_name: $strive_agent_last_name

export const CREATE_BUYERS = gql`
mutation createBuyer(
    $arcimedes_row_id: ID,
    $status: String,
    $agent: String,
    $agent_firm: String,
    $first_name: String!,
    $last_name: String!,
    $company_name: String,
    $company_address: String,
    $company_city: String,
    $company_state: String,
    $company_zip: String,
    $email: String,
    $phone: String,
    $notes: String,
    $profile: String,
    $category: String,
    $type: String,
    $single_tenant_subcategory: String,
    $multi_tenant_subcategory: String,
    $market: String,
    $price_min: Int,
    $price_max: Int,
    $cap_rate_min: Int,
    $cap_rate_max: Int,
    $strive_agent: String,
    $cell_phone: String,
    $deleted: Int,
    $arcimedes_created: String,
    $arcimedes_created_by: String,
    $arcimedes_modified: String,
    $arcimedes_modified_by: String,  
) {
    createOrUpdateBuyer(input: {
        arcimedes_row_id: $arcimedes_row_id
        status: $status
        agent: $agent
        agent_firm: $agent_firm
        first_name: $first_name
        last_name: $last_name
        company_name: $company_name
        company_address: $company_address
        company_city: $company_city
        company_state: $company_state
        company_zip: $company_zip
        phone: $phone
        notes: $notes
        email: $email
        profile: $profile
        category: $category
        type: $type
        single_tenant_subcategory: $single_tenant_subcategory
        multi_tenant_subcategory: $multi_tenant_subcategory 
        market: $market
        price_min: $price_min
        price_max: $price_max
        cap_rate_min: $cap_rate_min
        cap_rate_max: $cap_rate_max
        strive_agent: $strive_agent
        cell_phone: $cell_phone
        deleted: $deleted
        arcimedes_created: $arcimedes_created
        arcimedes_created_by: $arcimedes_created_by
        arcimedes_modified: $arcimedes_modified
        arcimedes_modified_by: $arcimedes_modified_by  
    }) {
        buyer {
            arcimedes_row_id
            status
            agent
            agent_firm
            first_name
            last_name
            company_name
            company_address
            company_city
            company_state
            company_zip
            phone
            email
            notes
            profile
            category
            type
            single_tenant_subcategory
            multi_tenant_subcategory
            market
            price_min
            price_max
            cap_rate_min
            cap_rate_max
            strive_agent
            strive_agent_last_name
            cell_phone
            deleted
            arcimedes_created
            arcimedes_created_by
            arcimedes_modified
            arcimedes_modified_by
        }
    }
}
`